import { useMarketplaceServiceRecommendation } from '../../../../../fulfillment-planner/marketplace-service-recommendation/use-marketplace-service-recommendation';
import style from './style.module.less';
import { MarketplaceServiceRecommendationBanner } from '../../../../../fulfillment-planner/marketplace-service-recommendation/marketplace-service-recommendation-banner';

const RecommendedShippingService = () => {
  const recommendation = useMarketplaceServiceRecommendation();
  if (!recommendation) {
    return null;
  }

  return (
    <>
      <div className={style.label} />
      <div>
        <MarketplaceServiceRecommendationBanner
          marketplaceId={recommendation.marketplaceId}
          recommendedShippingService={recommendation.recommendedShippingService}
        />
      </div>
      <div className={style.center} />
    </>
  );
};

export default RecommendedShippingService;
